module.exports = __webpack_public_path__ + "static/media/20210411_150928_643_IMG_0465.c81c70ce.jpg";